import Swiper from 'swiper';
// import Swiper styles
import 'swiper/css';
window.addEventListener('DOMContentLoaded', ()=>{
    const silders = document.querySelectorAll('.mySwiper')
    if(silders.length>0){
        silders.forEach(silder=>{
            var swiper = new Swiper(silder, {
                slidesPerView: 4,
                spaceBetween: 0,
              });
        })
    }
})